import { VASTParser } from '@dailymotion/vast-client';
import Vast from '../index';
import { fetchVmapUrl } from '../lib';
import { timeToSeconds } from '../../../PlayerServices';
// Resolves once the data has been read - prerolls are announced by handleVMAP, when all of
// them are in.
export function parseInlineVastData(vastAdData, adType) {
  const xmlString = (new XMLSerializer()).serializeToString(vastAdData);
  const vastXml = (new window.DOMParser()).parseFromString(xmlString, 'text/xml');
  const vastParser = new VASTParser();

  return vastParser.parseVAST(vastXml)
    .then((parsedVAST) => {
      const ads = parsedVAST.ads ?? [];
      if (adType === 'postroll') {
        this.postRollData = ads;
      } else if (adType === 'preroll') {
        this.adsArray.push(...ads);
      } else if (adType === 'midroll') {
        this.adsArray.push(...ads);
        this.readAd();
      }
    })
    .catch(() => {
      if (adType === 'postroll' || adType === 'midroll') {
        this.disablePostroll();
      }
    });
}

export async function handleVMAP(vmapUrl) {
  try {
    const vmap = await fetchVmapUrl(vmapUrl);

    if (vmap.adBreaks && vmap.adBreaks.length > 0) {
      this.addEventsListeners();

      // Handle preroll
      const prerolls = Vast.getPreroll(vmap.adBreaks);
      if (!prerolls.length) {
        this.disablePreroll();
      } else {
        // contrib-ads opens a single ad break for prerolls, so all of them are collected into
        // one queue and announced with one 'adsready', once every one of them has settled.
        // Announcing them one by one instead let the content resume between two prerolls, and
        // a preroll that failed announced a break with nothing to play in it.
        Promise.all(prerolls.map((preroll) => {
          if (preroll.adSource?.adTagURI?.uri) {
            return this.handleVAST(preroll.adSource.adTagURI.uri);
          }
          if (preroll.adSource?.vastAdData) {
            return this.parseInlineVastData(preroll.adSource.vastAdData, 'preroll');
          }
          return null;
        })).then(() => {
          if (this.adsArray.length) {
            this.player.trigger('adsready');
          } else {
            this.disablePreroll();
          }
        });
      }

      // Handle postroll
      const postroll = Vast.getPostroll(vmap.adBreaks);
      if (!postroll) {
        this.disablePostroll();
      } else if (postroll.adSource?.adTagURI?.uri) {
        this.postRollUrl = postroll.adSource.adTagURI.uri;
      } else if (postroll.adSource?.vastAdData) {
        this.parseInlineVastData(postroll.adSource?.vastAdData, 'postroll');
      }

      // this.watchForProgress = Vast.getMidrolls(vmap.adBreaks);
      // if (this.watchForProgress.length > 0) {
      //   // listen on regular content for midroll handling
      //   this.player.on('timeupdate', this.onProgress);
      // }

      // Handle midrolls
      this.watchForProgress = Vast.getMidrolls(vmap.adBreaks);
      if (this.watchForProgress.length > 0) {
        this.player.on('timeupdate', this.onProgress);
        this.player.on('seeking', () => {
          const currentTime = this.player.currentTime();
          let lastSmallerOrEqualIndex = -1;
          for (let i = 0; i < this.watchForProgress.length; i++) {
            if (timeToSeconds(this.watchForProgress[i].timeOffset) <= currentTime) {
              lastSmallerOrEqualIndex = i;
            }
          }
          if (lastSmallerOrEqualIndex > 0 && this.watchForProgress.length > 1) {
            this.watchForProgress = this.watchForProgress.slice(lastSmallerOrEqualIndex);
          }
        });
      }
    } else {
      this.disableAllAds();
    }
  } catch (err) {
    console.error('Error handling VMAP:', err);
    this.disableAllAds();
  }
}
